import React from "react";
import LearnMoreModal from "../layout/LearnMoreModal";
import { TD_DIFFICULTY_SCORE_HELP } from "../../Views/ConstForTestDriveSection";
import "./BuiltInTests.scss";

import { 
    findAllMostFrequentStrings, 
    calculateAverageTrialTime, 
    calculateAverageReactionTime, 
    calculateAverageHoldTime, 
    calculateAverageHiddenTime,
    countAwaitedReleases, 
    calculateAverageExtraActivations, 
    calculateDifficulty
} from "./resources/ReactionTestCalcs";

function DisplayReactionResults(props){
  const completedTests = props.completedTests || [];

  return(
    <div>
    {(completedTests.length > 0) 
      ? 
      <>
      <h2>Activity Complete! Good job!</h2>
      <div className="aa-review-row"> 
        <p>
          <strong>Difficulty score: </strong>
          <DifficultyPrint number={calculateDifficulty(completedTests)} />
          <span>&nbsp;&nbsp;&nbsp;</span>
          <LearnMoreModal buttonClassName="aa-no-padding aa-secondary-link" linkText="" 
            title="Difficulty Score" content={TD_DIFFICULTY_SCORE_HELP}/>
        </p>
      </div>
      <table className="aa-test-table">
        <thead>
          <tr>
            <th>Trial</th>
            <th>Switch</th>
            <th>Reaction Time (sec)</th>
            <th>Hold Time (sec)</th>
            <th>Trial Time (sec)</th>
            {/* <th>Hidden Time (sec)</th>
            <th>Awaited Release</th> */}
            <th>Extra Hits</th>
          </tr>
        </thead>
        <tbody>
        {completedTests.map((t, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{t.activationType}</td>
              <td><PrettyPrint numberStr={((t.reactionTime / 1000)).toFixed(1)}/></td>
              <td><PrettyPrint numberStr={((t.holdTime / 1000)).toFixed(1)}/></td>
              <td><PrettyPrint numberStr={((t.trialTime / 1000)).toFixed(1)}/></td>
              {/* <td><PrettyPrint numberStr={((t.hiddenTime / 1000)).toFixed(2)}/></td>
              <td>{t.awaitedRelease.toString()}</td> */}
              <td>{t.extraActivations.toFixed(0)}</td>
            </tr>
          ))}
          <tr className="aa-average-row" key={completedTests.length + 1}>
            <td>Average</td>
            {/* <td><ArrayPrint array={findAllMostFrequentStrings(completedTests)}/></td> */}
            <td>-</td>
            <td><PrettyPrint numberStr={(calculateAverageReactionTime(completedTests)/1000).toFixed(1)}/></td>
            <td><PrettyPrint numberStr={(calculateAverageHoldTime(completedTests)/1000).toFixed(1)}/></td>
            <td><PrettyPrint numberStr={(calculateAverageTrialTime(completedTests)/1000).toFixed(1)}/></td>
            {/* <td><PrettyPrint numberStr={(calculateAverageHiddenTime(completedTests)/1000).toFixed(2)}/></td>
            <td><PrettyPrint numberStr={countAwaitedReleases(completedTests).toFixed(0)}/></td> */}
            <td><PrettyPrint numberStr={calculateAverageExtraActivations(completedTests).toFixed(1)}/></td>
          </tr>
        </tbody>
      </table>
      </>
      :
      <p>There are no data to display.</p>
    }
    </div>
  );
}

function ArrayPrint(props){
    const array = props.array;
      // Format the most frequent strings as [,]
    let formattedMostFrequentStrings;
    if(!props.array || props.array.length === 0)
        formattedMostFrequentStrings = '';
    else if(props.array.length === 1)
        formattedMostFrequentStrings = array[0];
    else
        formattedMostFrequentStrings = `[${array.join(', ')}]`;
    return formattedMostFrequentStrings;
}

function PrettyPrint(props){
  const numberStr = props.numberStr;
  if (numberStr && ((numberStr==='NaN') || (numberStr==='Infinity'))){
    return("-");
  }
  else return(numberStr);
}

function DifficultyPrint(props){
  const number = props.number;
  let ret = number.toFixed(2);
  let faClass = "fa ";
  let backgroundColor = "rgba(0, 128, 0, 0.33)";

  if(number < 1.75){
    ret += ' (low';
    faClass += "fa-smile-o";
  }
  else if(number >= 1.75 && number < 2.5){
    ret += ' (medium';
    faClass += "fa-meh-o";
    backgroundColor = "rgba(255, 215, 0, 0.33)";
  }
  else{
    ret += ' (high';
    faClass += "fa-frown-o";
    backgroundColor = "rgba(255, 0, 0, 0.33)";
  }
  
  return(
    <span>{ret} <i className={faClass} style={{backgroundColor: `${backgroundColor}`, borderRadius: "10px"}}></i>)</span>
  );
}



export default DisplayReactionResults;
